import {SELECT_APPLICATION_ACCESS_LICENSE} from '../action-types';

export const initialState = {
  license: {},
};

export const licenseSelectedReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case SELECT_APPLICATION_ACCESS_LICENSE:
      return {
        ...state,
        license: action.payload,
      };
    default:
      return state;
  }
};
